import { useAuth0 } from "@auth0/auth0-react";
import { Avatar } from "@material-ui/core";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Action from "components/ActionPopOver";
import MyButton from "components/MyButton";
import Loader from "components/loader/Loader";
import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { useHistory } from "react-router-dom";
import Details from "./Details";
import Education from "./Education";
import Events from "./Events";
import "./index.scss";

import AuthService from "Lib/API/Auth/index";
import { formatDate } from "helper";
import ProfileCompletion from "./ProfileCompletion";
const MembersDrawer = ({ setOpenConfirmDelete, setMemberToRemove,contactId, showDelete }) => {
  const { getAccessTokenSilently } = useAuth0();
  const [getContactLoading, setGetContactLoading] = useState(true );
  const [contactData, setContactData] = useState(null);

  const calculateProfileCompletion = (user) => {
    const {
      account,
      createdAt,
      id,
      member_id,
      profile_img,
      relationship,
      _id,
      backGround,
      account_id,
      organization,
      updatedAt,
      __v,
      ...data
    } = { ...(user ? user : {}) };
    const insertedValues = Object.values(data);
    const insertedValuesLng = insertedValues.filter((it) => {
      if (it !== "") {
        if (typeof it === "object") {
          if (it?.formattedAddress !== undefined) {
            return true;
          } else return false;
        }
        return true;
      } else return false;
    })?.length;
    return Math.round((insertedValuesLng / 23) * 100) > 100
      ? 100
      : Math.round((insertedValuesLng / 23) * 100);
  };
  const colors = ["#4CAF50", "#2A99FA"];


  const getContactHandler = async () => {
    setGetContactLoading(true);
    const token = await getAccessTokenSilently();
    AuthService.getContactById(contactId, token)
      .then((res) => {
        if(!res?.length) return;
        const result = { ...res?.[0] };
        result.id = result._id;
        const random = Math.floor(Math.random() * 2);
        if (!result.profile_img) {
          result.backGround = colors[random];
        }
        result.profile_completion = calculateProfileCompletion(result);
        setContactData(result);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setGetContactLoading(false);
      });
  }
  useEffect(() => {
    if(!contactId) return;
    getContactHandler();
  },[contactId])




  const [selected, setSelected] = useState("details");
  const history = useHistory();
  const TabContent = () => {
    switch (selected) {
      case "details":
        return <Details member={contactData} />;
      case "events":
        // return <Events />;
        return <Events />;
      case "edication":
        // return <Education />;
        return <Education />;
      default:
        return (
          <div className="w-100 h-100 d-flex justify-content-center align-items-center">
            <Loader />
          </div>
        );
    }
  };
  const member_type_colors = [
    {
      color: "rgba(36, 85, 239,1)",
      background: "rgba(36, 85, 239,0.1)",
    },
    {
      color: "rgba(76, 175, 80, 1)",
      background: "rgba(76, 175, 80, 0.1)",
    },
  ];
  return (
    <div className="account-drawer">
      {getContactLoading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>
          <Loader />
        </div>
      ) : (
      <>
      <div className="account-drawer-header px-5 pt-5">
        <div className="account-header">
          <div className="name">
            <Avatar
              className="avatar"
              alt={`${contactData?.first_name} ${contactData?.last_name}`}
              src={contactData?.profile_img ? contactData?.profile_img : "/example.jpg"}
              style={{ marginRight: "5px", background: contactData?.backGround }}
            >
              {/* <div className="name">
                {(account?.first_name?.[0] + account?.last_name?.[0]).toUpperCase()}
              </div> */}
            </Avatar>
            <span
              className="cursor-pointer"
              onClick={() =>
                history.push(`/member-details/${contactData?.account_id}/family-member`, contactData)
              }
            >{`${contactData?.first_name} ${contactData?.last_name}`}</span>
          </div>
          <div className="cursor-pointer">
            <Action
              onEditClick={() =>
                history.push(`/member-details/${contactData?.account_id}/family-member`, contactData)
              }
              onDeleteClick={showDelete ? () => {
                setMemberToRemove(contactData);
                setOpenConfirmDelete(true);
              } : false}
              checkActive={true}
              style={{
                color: "#3f4255",
                width: "16px",
                height: "16px",
              }}
            />
          </div>
        </div>
        <div className="account-id py-1">#{contactData?.member_id}</div>
        <div className="account-creation-date account-badge pb-4">
          Created date{" "}
          {formatDate({date:contactData?.createdAt, formatType: "defaultWithUTC"})}
        </div>
        <div className="d-flex justify-content-between">
          <div
            className="member-type"
            style={
              contactData?.account_permission === "admin"
                ? member_type_colors[1]
                : member_type_colors[0]
            }
          >
            {contactData?.account_permission === "admin"
              ? "Admin"
              : "Family member"}
          </div>
          <div className="">
            <MyButton disabled content="Message me" />
          </div>
        </div>
        <div
          className="profile-com"
          onClick={() =>
            history.push(`/member-details/${contactData?.account_id}/family-member`, contactData)
          }
        >
          <ProfileCompletion
            profile={contactData?.profile_completion || 0}
            handleClick={() =>
              history.push(`/member-details/${contactData?.account_id}/family-member`, contactData)
            }
          />
          <ChevronRightIcon />
        </div>
      </div>
      <hr className="mt-0" />
      <div className="account-drawer-content">
        {/* <div className="account-drawer-tabs">
          <div className="toggle-bar">
            <p
              className={selected === "details" ? "selected" : "unselected"}
              onClick={() => setSelected("details")}
            >
              <span className="title">Details</span>
            </p>
            <p
              className={selected === "events" ? "selected" : "unselected"}
              onClick={() => setSelected("events")}
            >
              <span className="title">Events</span>
            </p>
            <p
              className={selected === "edication" ? "selected" : "unselected"}
              onClick={() => setSelected("edication")}
            >
              <span className="title">Education</span>
            </p>
          </div>
        </div> */}
        <div className="tab-content p-5">
          <TabContent />
        </div>
      </div>
      </>
    )}
    </div>
  );
};

export default MembersDrawer;
